'use strict'
import numeral from 'numeral'

numeral.register('format', 'hours', {
  regexps: {
    format: /(h)/,
    unformat: /(h)/
  },
  format: function(value, format, roundingFunction) {
    var space = numeral._.includes(format, ' h') ? ' ' : '',
      output;

    // check for space before h
    format = format.replace(/\s?\%/, '');

    output = numeral._.numberToFormat(value, format, roundingFunction);

    if (numeral._.includes(output, ')')) {
      output = output.split('');

      output.splice(-1, 0, space + 'h');

      output = output.join('');
    } else {
      output = output + space + 'h';
    }

    return output;
  },
  unformat: function(string) {
    return numeral._.stringToNumber(string);
  }
})
